import { PhoneVerificationAdapters } from '../adapters';
import { sendOtp as sendOtpClient } from '../clients/SendOtp';
import { setPhone as setPhoneClient } from '../clients/SetPhone';
import { verifyOtp as verifyOtpClient } from '../clients/VerifyOtp';
import { PhoneVerificationApiError } from '../errors';
import type {
  ISendMfaCodeRequest,
  IVerifyMfaCodeRequest,
} from '../types/PhoneVerification';

const chainTypedErrors = (error: unknown): Error =>
  PhoneVerificationApiError.fromAxiosError(error) ??
  (error instanceof Error ? error : new Error(String(error)));

const sendMfaCode = async (input: ISendMfaCodeRequest): Promise<void> => {
  try {
    await sendOtpClient(PhoneVerificationAdapters.toSendOtpPayload(input));
  } catch (error) {
    throw chainTypedErrors(error);
  }
};

const verifyMfaCode = async (input: IVerifyMfaCodeRequest): Promise<void> => {
  try {
    const { requestToken } = await verifyOtpClient(
      PhoneVerificationAdapters.toVerifyOtpPayload(input),
    );
    await setPhoneClient(PhoneVerificationAdapters.toSetPhonePayload(input, requestToken));
  } catch (error) {
    throw chainTypedErrors(error);
  }
};

export const PhoneVerificationService = {
  sendMfaCode,
  verifyMfaCode,
};
